import { createSvgIcon } from 'shared/icons/IconUtils';

export const DisabledBookmark = createSvgIcon(
  'DisabledBookmark',
  <path
    d="M5.833 2.5h8.334c.916 0 1.666.75 1.666 1.667v.272l-1.666.963V4.167H5.833v6.046l-1.662.96.004-7.006c0-.917.742-1.667 1.658-1.667ZM4.168 15.023 4.167 17.5 10 15l5.833 2.5V8.288l-1.666.963V15L10 13.183 5.833 15v-.938l-1.665.961ZM18.715 4.7a.833.833 0 0 1-.305 1.138L2.083 15.265a.833.833 0 1 1-.833-1.444l16.326-9.426a.833.833 0 0 1 1.139.305Z"
    fill="currentColor"
  />,
  { viewBox: '0 0 20 20', width: 20, height: 20, fill: 'none' },
);
